import { render, staticRenderFns } from "./OzIcon.vue?vue&type=template&id=661fdd34&scoped=true&"
import script from "./OzIcon.vue?vue&type=script&lang=ts&"
export * from "./OzIcon.vue?vue&type=script&lang=ts&"
import style0 from "./OzIcon.vue?vue&type=style&index=0&id=661fdd34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661fdd34",
  null
  
)

/* custom blocks */
import block0 from "./OzIcon.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports